import RoomListItem from './RoomListItem'
import './RoomListItem.css'

export default RoomListItem



// WEBPACK FOOTER //
// ./src/features/Hotel/components/RoomListItem/index.js